// Acronyms that should stay uppercase
// cspell:ignore HVAC
const ACRONYMS = ['HVAC', 'SPAM', 'API', 'URL', 'ID', 'SMS', 'FAQ', 'DIY', 'AC', 'TV'];

// Custom label mappings for specific values
const LABEL_MAPPINGS: Record<string, string> = {
    'form-widget': 'Form',
    'widget': 'Chat'
};

/**
 * Formats a label to be more readable:
 * - QUOTE_REQUEST -> Quote Request
 * - roofing -> Roofing
 * - HVAC -> HVAC (keeps acronyms uppercase)
 * - form-widget -> Form (custom mapping)
 * - widget -> Chat (custom mapping)
 */
export const formatLabel = (label: string): string => {
    if (!label) return label;

    // Check for custom label mappings first
    if (LABEL_MAPPINGS[label]) {
        return LABEL_MAPPINGS[label];
    }

    // Check if it's an acronym (all caps and in our list)
    const upperLabel = label.toUpperCase();
    if (ACRONYMS.includes(upperLabel)) {
        return upperLabel;
    }

    // Replace underscores with spaces and convert to title case
    return label
        .replace(/_/g, ' ')
        .toLowerCase()
        .split(' ')
        .map(word => {
            // Check if word is an acronym
            const upperWord = word.toUpperCase();
            if (ACRONYMS.includes(upperWord)) {
                return upperWord;
            }
            // Capitalize first letter
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
};
